const sortObjectAlphabetically = (value: unknown): unknown => {
  if (value === null || typeof value !== 'object') {
    return value;
  }

  if (Array.isArray(value)) {
    return value.map(sortObjectAlphabetically);
  }

  const original = value as Record<string, unknown>;
  const sorted: Record<string, unknown> = {};

  for (const key of Object.keys(original).sort()) {
    sorted[key] = sortObjectAlphabetically(original[key]);
  }

  return sorted;
};

export const stringifyAlphabeticalObject = (value: unknown): string =>
  JSON.stringify(sortObjectAlphabetically(value));
